export default class SearchEngineAdapter {
    constructor(data = [], query = '') {
        this.data = data.data ?? data;
        this.aggregation = data.aggregations?.count_by_type;
        this.result = {};
        this.query = query;
    }

    build(showArchived = false) {
        this.result = this.getStructure();
        return this.feed(this.extractDataByType(showArchived));
    }

    extractDataByType(showArchived) {
        if (!Array.isArray(this.data)) {
            this.data = [this.data];
        }

        if (this.data) {
            return this.data.filter((item) => {
                if (showArchived) {
                    return item.object.type === this.key;
                }
                return item.object.type === this.key && !item.is_archived;
            });
        }
        return [];
    }

    feed(data) {
        if (data.length > 0) {
            this.result.items = data.map((item) => this.formatItem(item));
        }
        if (this.aggregation) {
            this.result.count = this.aggregation[this.key]
                ? this.aggregation[this.key][0]
                : this.result.items.length;
        } else {
            this.result.count = this.result.items.length;
        }
        return this.result;
    }

    formatAddress(address) {
        // perform check here
        if (address) {
            let formattedAddress = address.id ? `${address.postal_code} ${address.city}` : '';
            if (formattedAddress !== '' && address.country_code !== 'FR') {
                formattedAddress += ' ' + address.country_code;
            }
            return formattedAddress;
        }
        return false;
    }

    checkFieldForHighlighting(field, isExtraField) {
        const terms = this.query.split(' ').filter((term) => term !== '');

        if (this.query.length === 0) {
            return isExtraField ? null : field;
        }

        const safeTerms = terms.map((term) => this.escapeSpecialCharacters(term));

        const regex = new RegExp(`(${safeTerms.join('|')})`, 'gi');

        if (!field.match(regex)) {
            return isExtraField ? null : field;
        }

        return field.replace(regex, '<span class="highlight">$1</span>');
    }

    escapeSpecialCharacters(string) {
        // escape special characters and make optional
        return string.replaceAll(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&?');
    }

    stripTags(string) {
        return string.replace(/(<([^>]+)>)/gi, '');
    }

    checkFieldForQuery(field, isExtraField = false) {
        const cleanQuery = this.query.replaceAll(' ', '');

        if (!field) {
            return isExtraField ? null : field;
        }

        if (!isNaN(cleanQuery) && cleanQuery.length > 6) {
            // is probably a phone number
            let searchTerm = cleanQuery;
            if (cleanQuery.charAt(0) === '0') {
                searchTerm = cleanQuery.substring(1);
            } else if (cleanQuery.charAt(0) === '+') {
                searchTerm = this.escapeSpecialCharacters(cleanQuery);
            }

            const regex = new RegExp(`(${searchTerm})`, 'gi');

            if (!field.match(regex)) {
                return isExtraField ? null : field;
            }

            return field.replace(regex, '<span class="highlight">$1</span>');
        } else {
            return this.checkFieldForHighlighting(field, isExtraField);
        }
    }
}
